import Vue from "vue"
import Vuex from "vuex"

import * as url from "../utils/url"
import * as types from "./mutation-types"
import * as report from "../utils/report"
import * as ua from "../utils/ua"
import Wechat from "../utils/wechat"
import cookies from "../utils/cookies"
import * as userApi from "../api/user"
import * as bargainApi from "../api/bargain"
import * as config from "../config"
import * as uuid from "../utils/uuid"
import cookie from "../utils/cookies"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sandbox: url.getParam("sandbox"),
    pf: url.getParam("pf"),
    aid: url.getParam("aid"),
    offerId: url.getParam("offerId"),
    openid: "",
    openkey: "",
    sessionId: "",
    sessionType: "",
    wxAppid2: "wx951bdcac522929b6",
    provideOpenid: cookies.get("uin").substr(1) * 1,
    provideOpenkey: cookie.get("skey"),
    provideSessionId: "uin",
    provideSessionType: "skey",
    avatar: "",
    qqNickname: "",
    wechatBindQQ: "",
    isLoading: false,
    toastMsg: "",
    dialogMsg: "",
    isPtloginShown: false,
    isPageLoading: false,
    bargainGroup: config.GAME_INFO[url.getParam("offerId")].BARGAIN_GROUP,
    gameCheckType: "",
    bargainList: "",
    bargainInfo: "",
    zoneInfo: "",
    selectedZone: "",
    roleInfo: "",
    selectedRole: "",
    isOpenerFirstBargain: false,
    successBargainNum: "",
    billNo: "",
    userAgent: ua.getUserAgent()
  },
  getters: {
    sandbox: state => state.sandbox,
    pf: state => {
      return state.pf
      // if (state.pf) {
      //   return state.pf
      // } else {
      //   let userAgent = ua.getUserAgent()
      //   if (userAgent.weixin) {
      //     return langs.WECHAT_STORE_PF_DEFAULT_ENTRANCE
      //   } else if (userAgent.QQ) {
      //     return langs.MQQ_STORE_PF_DEFAULT_ENTRANCE
      //   }
      // }
    },
    gameCheckType: state => {
      return config.GAME_INFO[state.offerId].CHECK_TYPE
    },
    gameType: state => {
      return config.GAME_INFO[state.offerId].GAME_TYPE
    },
    isPfFromWechatWallet: state => {
      if (
        ["__mds_wx", "__mds_sq", "__mds_qq"].some(prefix => {
          return state.pf.indexOf(prefix) > -1
        })
      ) {
        return true
      } else {
        return false
      }
    },
    loginState: state => {
      return {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType
      }
    },
    provideLoginState: state => {
      return {
        openid: state.provideOpenid,
        openkey: state.provideOpenkey,
        sessionId: state.provideSessionId,
        sessionType: state.provideSessionType
      }
    },
    successBargainNum: state => state.successBargainNum,
    bargainList: state => state.bargainList,
    bargainInfo: state => state.bargainInfo,
    zoneInfo: state => state.zoneInfo,
    selectedZone: state => state.selectedZone,
    roleInfo: state => state.roleInfo,
    selectedRole: state => state.selectedRole,
    isOpenerFirstBargain: state => state.isOpenerFirstBargain
  },
  actions: {
    jumpToMqq({ state }, jumpUrl) {
      if (!jumpUrl) {
        //默认跳活动首页
        let search = url.delParam("productId", location.search)
        jumpUrl = `${config.GAME_INFO[state.offerId].BARGAIN_URL}${search}`
      }
      if (state.userAgent.weixin) {
        let wechat = new Wechat()
        wechat.api(
          "getInstallState",
          {
            packageUrl: "mqq://",
            packageName: "com.tencent.mobileqq"
          },
          res => {
            if (/get_install_state:yes/.test(res.err_msg)) {
              userApi.jumpToMqq(jumpUrl, state)
            } else {
              alert("请先下载手机QQ！")
            }
          }
        )
      } else {
        userApi.jumpToMqq(jumpUrl, state)
      }
    },
    jumpToWechat({ state }, url) {
      let iframeDom = document.createElement("iframe")
      iframeDom.style.display = "none"

      iframeDom.src = url
      iframeDom.onload = iframeDom.onerror = () => {
        document.body.removeChild(iframeDom)
        iframeDom.onload = iframeDom.onerror = null
      }
      document.body.appendChild(iframeDom)
      location.href = url
      state.offerId
    },
    showShareMenu({ state }) {
      userApi.showShareMenu(state)
    },
    shareMessageInQQ({ state }, pf = "__mds_qqbargain.share") {
      userApi.shareMessageInQQ({
        title: config.GAME_INFO[state.offerId].SHARE_TITLE,
        desc: config.GAME_INFO[state.offerId].SHARE_DESC,
        img: config.GAME_INFO[state.offerId].SHARE_ICON,
        pf
      })
    },
    setOnShareHandler({ state }) {
      let params = {
        title: config.GAME_INFO[state.offerId].SHARE_TITLE,
        desc: config.GAME_INFO[state.offerId].SHARE_DESC,
        // // link: location.href,
        // link: `${location.origin}${location.pathname}${location.search}${location.hash}`,
        wxAppid2: state.wxAppid2,
        img: config.GAME_INFO[state.offerId].SHARE_ICON
      }
      let userAgent = ua.getUserAgent()
      if (userAgent.QQ) {
        params.pf = "__mds_qqbargain.share"
        userApi.setOnMqqShareHandler(params)
      } else if (userAgent.weixin) {
        params.pf = "__mds_wxbargain.share"
        userApi.setOnWechatShareHandler(params)
      }
    },
    getLoginState({ state, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        if (!state.openid || !state.openkey) {
          let userAgent = ua.getUserAgent()
          if (userAgent.weixin) {
            let wechat = new Wechat({
              getDetail: 1
            })
            if (wechat.init()) {
              wechat.getOpenid({
                onSuccess: function() {
                  commit(types.SET_USER_LOGIN_STATE, {
                    openid: this.openid,
                    openkey: this.accessToken,
                    sessionId: "hy_gameid",
                    sessionType: "wc_actoken"
                  })
                  resolve({
                    openid: this.openid,
                    openkey: this.accessToken,
                    userInfo: this.info
                  })
                },
                onError: () => {
                  reject()
                }
              })
            } else {
              reject()
            }
          } else if (userAgent.QQ) {
            let loginState = {
              openid: cookies.get("uin").substr(1) * 1,
              openkey: cookies.get("skey"),
              sessionId: "uin",
              sessionType: "skey"
            }
            commit(types.SET_USER_LOGIN_STATE, loginState)
            // dispatch("getQQNickname", loginState.openid)
            // commit(types.SET_USER_AVATAR, `${location.protocol}//my.pay.qq.com/cgi-bin/account/get_qq_face.cgi?uin=${loginState.openid}`)
            resolve(loginState)
          } else if (window._msdkLoginParams) {
            if (_msdkLoginParams.acctype === "wx" || _msdkLoginParams.acctype === "weixin") {
              let loginState = {
                openid: _msdkLoginParams.openid,
                openkey: _msdkLoginParams.access_token,
                sessionId: "hy_gameid",
                sessionType: "wc_actoken",
                wxAppid2: _msdkLoginParams.appid,
                accountType: "wx"
              }
              commit(types.SET_USER_LOGIN_STATE, loginState)
              resolve(loginState)
            } else if (_msdkLoginParams.acctype === "qq") {
              /**
               *  {
    "acctype": "qq",
    "appid": "1104922185",
    "openid": "4C5782CCFEF74AE493A71B526C43DDC1",
    "access_token": "E51744B676BDABA33EF0E9160609E279",
    "pay_token": "45DD6BF183D747520BCF974977835EFF",
    "platid": "0"
   }
               */
              let loginState = {
                openid: _msdkLoginParams.openid,
                openkey: _msdkLoginParams.access_token,
                sessionId: "openid",
                sessionType: "kp_accesstoken",
                accountType: "qq"
              }
              commit(types.SET_USER_LOGIN_STATE, loginState)
              resolve(loginState)
            } else {
              reject("无登陆态")
            }
          } else {
            dispatch("reportUserAction", {
              iformat: config.REPORT.PAGEVIEW.OUTGAME_BARGAIN_NON_WECHAT_AND_QQ
            })
            reject("无登陆态")
          }
        } else {
          resolve({
            openid: state.openid,
            openkey: state.openkey,
            sessionId: state.sessionId,
            sessionType: state.sessionType,
            wxAppid2: state.wxAppid2
          })
        }
      }).then(loginState => {
        document.querySelector("#page_loading").style.display = "none"
        return loginState
      })
    },
    getWechatBindQQAndNickName({ dispatch }) {
      return dispatch("getWechatBindQQ").then(qquin => {
        return dispatch("getQQNickname", qquin)
      })
    },
    getQQNickname({ commit, state }, provideUin) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        session_id: state.sessionId,
        session_type: state.sessionType,
        offerId: "1450000186",
        sandbox: state.sandbox,
        provide_uin: provideUin
      }
      return userApi.getQQNickname(params).then(nickname => {
        commit(types.SET_USER_NICKNAME, nickname)
      })
    },
    getWechatBindQQ({ commit, state }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        session_id: state.sessionId,
        session_type: state.sessionType,
        sandbox: state.sandbox,
        offerId: state.offerId,
        WxAppid: state.wxAppid2
      }
      return userApi.getWechatBindQQ(params).then(qquin => {
        commit(types.SET_WECHAT_BIND_QQ, qquin)
        return qquin
      })
    },
    getAllBargainList({ state, commit }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: state.offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: state.bargainGroup
      }
      return bargainApi.getActivities(params).then(info => {
        if (info && info.buybargain && info.buybargain.bargain) {
          commit(types.SET_BARGAIN_LIST, info.buybargain.bargain.rule_item)
          commit(types.SET_SUCCESS_BARGAIN_NUM, info.buybargain.bargain.bargain_success_num)
          return info.buybargain.bargain.rule_item
        }
      })
    },
    getMyBargains({ state }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: state.offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: state.bargainGroup
      }
      return bargainApi.getMyBargains(params)
    },
    getBargainById({ state, commit }, { bargainId, currentPage, pageSize }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: state.offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: state.bargainGroup,
        bargainId,
        currentPage,
        pageSize
      }
      return bargainApi.getBargains(params).then(info => {
        let bargainInfo = info.bargain_info
        bargainInfo.user_comm_id = info.user_comm_id
        if (currentPage == 1) {
          //第一页在设置砍价信息,后面的分页都是为了获取参砍人
          commit(types.SET_BARGAIN_INFO, bargainInfo)
          if (bargainInfo.bill_no) {
            commit(types.GENERATE_BILL_UUID, bargainInfo.bill_no)
          } else {
            commit(types.GENERATE_BILL_UUID, uuid.generate())
          }
        }
        return bargainInfo
      })
    },
    openBargain({ state }, productId) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: state.offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: state.bargainGroup,
        productId
      }
      return bargainApi.openBargain(params)
    },
    helpBargain({ state }, { productId, bargainId }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: state.offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: state.bargainGroup,
        bargainId,
        productId
      }
      return bargainApi.helpBargain(params)
    },
    pay({ state, getters }, bargainId) {
      let userAgent = ua.getUserAgent(),
        gameId
      /*
      gameid区分端游和手游拼接模式
      端游为 "大区id_角色id"
      手游为 "area(标识手Q还是微信)_角色id__分区id"
       */
      if (getters.gameType == config.GAME_TYPE.MOBILE_GAME) {
        gameId = [
          state.selectedZone.c || (userAgent.weixin ? "1" : "2"),
          getters.gameCheckType == config.CHECK_TYPE.NEED_SELECT_ROLE ? state.selectedRole.id : "",
          "",
          state.selectedZone.v
        ].join("_")
      } else if (getters.gameType == config.GAME_TYPE.PC_GAME) {
        gameId = [
          state.selectedZone.v,
          getters.gameCheckType == config.CHECK_TYPE.NEED_SELECT_ROLE ? state.selectedRole.id : "",
          "",
          ""
        ].join("_")
      }

      let extendParams = {}
      let hasCoinChannel = config.GAME_INFO[state.offerId].HAS_COIN_CHANNEL
      //feature:现金渠道支付如果走SDK协议需要穿zoneid
      if (hasCoinChannel) {
        extendParams.zoneid = [
          state.selectedZone.v,
          getters.gameCheckType == config.CHECK_TYPE.NEED_SELECT_ROLE ? state.selectedRole.id : ""
        ].join("_")
      }
      let params = {
        pf: `mds_wechat_gmshop-pay_html5_${state.pf}-${hasCoinChannel ? (userAgent.iOS ? "iap" : "android") : "html5"}`,
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: state.offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: state.bargainGroup,
        gameId,
        productId: state.bargainInfo.product_id,
        productNum: state.bargainInfo.product_num,
        productName: state.bargainInfo.product_name
      }

      return bargainApi.pay(params, extendParams).then(res => {
        return bargainApi.initMidas().then(Midas => {
          return new Promise(resolve => {
            Midas.buyGoods({
              params: `/v1/${res.mid}/${state.offerId}/mobile_goods_info?token_id=${res.token}&out_trade_no=${state.billNo}`,
              pf: `mds_wechat_gmshop-pay_html5_${state.pf}-html5`,
              sandbox: state.sandbox,
              drm_info: `bargain_group=${state.bargainGroup}&version=3.0&bargain_id=${bargainId}`,
              openid: state.openid,
              openkey: state.openkey,
              sessionid: state.sessionId,
              sessiontype: state.sessionType,
              wxAppid2: state.wxAppid2,
              closeOnSuccess: 1,
              hideUi: 1,
              hidePrice: 1,
              // directChannel: "wechat",
              onSuccess: resolve
            })
          })
        })
      })
    },
    gameCoinPay({ state, getters }, bargainId) {
      let gameId = ""
      /*
      gameid区分端游和手游拼接模式
      端游为 "大区id_角色id"
      手游为 "area(标识手Q还是微信)_角色id__分区id"
       */

      let params = {
        pf: `mds_wechat_gmshop-pay_html5_${state.pf}-${state.userAgent.iOS ? "iap" : "android"}`,
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        offerId: state.offerId,
        sandbox: state.sandbox,
        wxAppid2: state.wxAppid2,
        bargainGroup: state.bargainGroup,
        gameId,
        productId: state.bargainInfo.product_id,
        productNum: state.bargainInfo.product_num,
        productName: state.bargainInfo.product_name
      }

      return bargainApi
        .pay(params, {
          zoneid: [
            state.selectedZone.v || state.selectedZone.zone_id,
            getters.gameCheckType == config.CHECK_TYPE.NEED_SELECT_ROLE ? state.selectedRole.id : ""
          ].join("_")
        })
        .then(res => {
          return bargainApi.initMidas().then(Midas => {
            return new Promise(resolve => {
              let params = {
                params: `/v1/${res.mid}/${state.offerId}/mobile_goods_info?token_id=${res.token}&out_trade_no=${state.billNo}`,
                pf: `mds_wechat_gmshop-pay_html5_${state.pf}-${state.userAgent.iOS ? "iap" : "android"}`,
                sandbox: state.sandbox,
                drm_info: `bargain_group=${state.bargainGroup}&version=3.0&bargain_id=${bargainId}`,
                openid: state.openid,
                openkey: state.openkey,
                sessionid: state.sessionId,
                sessiontype: state.sessionType,
                wxAppid2: state.wxAppid2,
                closeOnSuccess: 1,
                hidePrice: 1,
                showCoin: 1,
                // change_wx_openid: 1,
                realPrice: state.bargainInfo.now_amt,
                dc: "bank,mcard,hfpay,yb,wsjpay,qqcard",
                // directChannel: "wechat",
                onSuccess: resolve
              }

              if (state.userAgent.iOS) {
                //iOS内仅支持点券支付
                params.dc = `${params.dc},wechat,qqwallet,qdqb,qbqd`
                params.hideUi = 1
                params.directChannel = "game_coin"
              }

              if (state.sessionType == "wc_actoken" && state.userAgent.weixin) {
                params.change_wx_openid = 1
              }

              Midas.buyGoods(params)
            })
          })
        })
    },
    getMobileZoneInfo({ state }) {
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        wxAppid2: state.wxAppid2,
        offerId: state.offerId,
        sandbox: state.sandbox,
        clientVersion: state.userAgent.iOS ? "iap" : "android"
      }
      return userApi.getMobileZones(params)
    },
    getZoneInfo({ state }) {
      let params = {
        offerId: state.offerId
      }
      return userApi.getZoneInfo(params)
    },
    getRoleInfo({ state }, { platformId, area, zoneid }) {
      let userAgent = ua.getUserAgent()
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        wxAppid2: state.wxAppid2,
        offerId: state.offerId,
        sandbox: state.sandbox,
        clientVersion: userAgent.iOS ? "iap" : "android",
        platformId,
        area,
        zoneid
      }
      return userApi.getRoleInfo(params)
    },
    getMobileRoleInfo({ state }, { zoneid }) {
      let userAgent = ua.getUserAgent()
      let params = {
        openid: state.openid,
        openkey: state.openkey,
        sessionId: state.sessionId,
        sessionType: state.sessionType,
        wxAppid2: state.wxAppid2,
        offerId: state.offerId,
        sandbox: state.sandbox,
        clientVersion: userAgent.iOS ? "iap" : "android",
        zoneid
      }
      return userApi.getMobileRoleInfo(params)
    },
    getPCGameRoleInfo({ state }, { zoneid, provideLoginState }) {
      let params = {
        openid: provideLoginState.openid,
        openkey: provideLoginState.openkey,
        sessionId: provideLoginState.sessionId,
        sessionType: provideLoginState.sessionType,
        offerId: state.offerId,
        sandbox: state.sandbox,
        zoneid
      }
      return userApi.getPCGameRoleInfo(params)
    },
    setZoneInfo({ commit }, zoneInfo) {
      commit(types.SET_ZONE_INFO, zoneInfo)
    },
    setSelectedZone({ commit }, zone) {
      commit(types.SET_SELECTED_ZONE, zone)
    },
    setRoleInfo({ commit }, roleInfo) {
      commit(types.SET_ROLE_INFO, roleInfo)
    },
    setSelectedRole({ commit }, role) {
      commit(types.SET_SELECTED_ROLE, role)
    },
    launchApp({ state }) {
      let userAgent = ua.getUserAgent(),
        t = 1000,
        hasApp = true,
        url = ""
      if (userAgent.QQ) {
        url = config.GAME_INFO[state.offerId].QQ_SCHEMA
      } else {
        url = config.GAME_INFO[state.offerId].WECHAT_SCHEMA
      }
      setTimeout(function() {
        if (!hasApp) {
          //未安装app
          window.location.href = config.GAME_INFO[state.offerId].GAME_SCHEMA
        }
      }, 2000)

      let t1 = Date.now()
      // let ifr = document.createElement("iframe")
      // ifr.src = url
      // ifr.style.display = "none;"
      // document.body.appendChild(ifr)

      let iframeDom = document.createElement("iframe")
      iframeDom.style.display = "none"

      iframeDom.src = url
      iframeDom.onload = iframeDom.onerror = () => {
        document.body.removeChild(iframeDom)
        iframeDom.onload = iframeDom.onerror = null
      }

      document.body.appendChild(iframeDom)
      setTimeout(function() {
        var t2 = Date.now()
        if (!t1 || t2 - t1 < t + 100) {
          hasApp = false
        }
      }, t)
    },
    reportUserAction({ state }, params) {
      let data = {
        3: state.openid,
        8: params.resultInfo || "",
        // 19: getters.currentItem && getters.currentItem.code,
        13: 1,
        21: params.iformat,
        26: `vip_m-${state.pf || "pay_html5"}_-html5`,
        24: state.offerId,
        37: state.sessionId,
        43: state.sessionType,
        41: "wx951bdcac522929b6",
        50: navigator.userAgent,
        // 51: getters.aid,
        36: location.href
      }

      setTimeout(() => {
        report.dataReport(data)
      }, 0)
    },
    setOpenerFirstBargain({ commit, dispatch }, isFirst) {
      commit(types.SET_OPENER_FIRST_BARGAIN, isFirst)
      if (isFirst) {
        dispatch("reportUserAction", { iformat: config.REPORT.PAGEVIEW.OPENER_FIRST_BARGAIN })
      } else {
        dispatch("reportUserAction", { iformat: config.REPORT.CLICK.FIRST_BARGAIN_DIALOG_CLOSE })
      }
    },
    msdkShareTo({ dispatch, state }, { selected, bargainId, pf }) {
      let shareParams = {
        title: config.GAME_INFO[state.offerId].SHARE_TITLE,
        desc: config.GAME_INFO[state.offerId].SHARE_DESC,
        url: `${config.GAME_INFO[state.offerId].BARGAIN_URL}?offerId=${state.offerId}&pf=${pf}&bargainGroup=${state.bargainGroup}${
          state.sandbox ? "&sandbox=" + state.sandbox : ""
        }#/open/${bargainId}`,
        imgData: config.GAME_INFO[state.offerId].IMG_MSDK_SHARE_ICON
      }

      if (selected === "weixin" || selected === "pengy") {
        shareParams.MsdkMethod = "WGSendToWeiXinWithUrl"
        shareParams.scene = selected === "weixin" ? "0" : "1"
        shareParams.mediaTagName = "MSG_INVITE"
        if (selected == "pengy") {
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.INGAME_SHARE_WX_TIMELINE
          })
        }
        if (selected == "weixin") {
          dispatch("reportUserAction", {
            iformat: config.REPORT.CLICK.INGAME_SHARE_WX_FRIENDS
          })
        }
      } else {
        shareParams.MsdkMethod = "WGSendToQQ"
        shareParams.scene = "1"
        dispatch("reportUserAction", {
          iformat: config.REPORT.CLICK.INGAME_SHARE_QQ_FRIENDS
        })
      }
      setTimeout(() => {
        window.msdkShare(JSON.stringify(shareParams))
      }, 100)
    }
  },
  mutations: {
    [types.SET_USER_LOGIN_STATE](state, { openid, openkey, sessionId, sessionType, wxAppid2 }) {
      state.openid = openid
      state.openkey = openkey
      state.sessionId = sessionId
      state.sessionType = sessionType
      wxAppid2 && (state.wxAppid2 = wxAppid2)
    },
    [types.SET_PROVIDE_LOGIN_STATE](state, { provideOpenid, provideOpenkey, provideSessionId, provideSessionType }) {
      state.provideOpenid = provideOpenid
      state.provideOpenkey = provideOpenkey
      state.provideSessionId = provideSessionId
      state.provideSessionType = provideSessionType
    },
    [types.SET_USER_AVATAR](state, avatar) {
      state.avatar = avatar
    },
    [types.SET_USER_NICKNAME](state, nickname) {
      state.qqNickname = nickname
    },
    [types.SET_SUCCESS_BARGAIN_NUM](state, num) {
      state.successBargainNum = num
    },
    [types.SET_BARGAIN_LIST](state, bargainList) {
      state.bargainList = bargainList
    },
    [types.SET_BARGAIN_INFO](state, bargainInfo) {
      state.bargainInfo = bargainInfo
    },
    [types.GENERATE_BILL_UUID](state, uuid) {
      state.billNo = uuid
    },
    [types.SET_ZONE_INFO](state, zoneInfo) {
      state.zoneInfo = zoneInfo
    },
    [types.SET_SELECTED_ZONE](state, zone) {
      state.selectedZone = zone
    },
    [types.SET_ROLE_INFO](state, roleInfo) {
      state.roleInfo = roleInfo
    },
    [types.SET_SELECTED_ROLE](state, role) {
      state.selectedRole = role
    },
    [types.SET_OPENER_FIRST_BARGAIN](state, isOpenerFirstBargain) {
      state.isOpenerFirstBargain = isOpenerFirstBargain
    },
    [types.SET_WECHAT_BIND_QQ](state, qquin) {
      state.wechatBindQQ = qquin
    }
  },
  strict: process.env.NODE_ENV === "debug"
})
